import vertex_01   from './shaders/vert_01.glsl'
import vert_water  from './shaders/vert_water.glsl'
import vert_galaxy from './shaders/vert_galaxy.glsl'

import frag_01     from './shaders/frag_01.glsl'
import frag_02     from './shaders/frag_02.glsl'
import frag_03     from './shaders/frag_03.glsl'
import frag_water  from './shaders/frag_water.glsl'
import frag_galaxy from './shaders/frag_galaxy.glsl'

export default
{
    vertex_01,
    vert_water,
    vert_galaxy,
    frag_01,
    frag_02,
    frag_03,
    frag_water,
    frag_galaxy
}